import { Popover } from '@mui/material';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import ChevronIcon from '../../../assets/svg/ChevronIcon';
import DownloadIcon from '../../../assets/svg/DownloadIcon';
import { REPORT_FORMAT_OPTIONS } from '../../../constants';
import { Button } from '../../Shared';

export const ButtonExport = ({
  options = REPORT_FORMAT_OPTIONS,
  disabled,
  onClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const onOpenPopover = e => {
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        title="Export"
        variant="blue"
        iconStart={
          <DownloadIcon
            className={twMerge(
              'w-5 h-5 text-brand-900',
              disabled && 'text-base-400',
            )}
          />
        }
        iconEnd={
          <ChevronIcon
            className={twMerge(
              'w-5 h-5 text-brand-900',
              disabled && 'text-base-400',
            )}
          />
        }
        disabled={disabled}
        onClick={onOpenPopover}
      />
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-lg mt-2 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[151px]',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="p-0.5 flex flex-col gap-0.5">
          <div className="px-2 py-1.5">
            <p className="text-[14px]/[20px] text-base-600 font-medium">
              Export as...
            </p>
          </div>
          {options.map(({ value, label, disabled }) => (
            <div
              key={value}
              className={twMerge(
                'px-2 py-1.5 cursor-pointer rounded-lg hover:bg-brand-300/[0.08]',
                disabled && 'hover:bg-transparent cursor-default',
              )}
              onClick={
                disabled
                  ? undefined
                  : () => {
                      onClick(value);
                      onClosePopover();
                    }
              }
            >
              <p
                className={twMerge(
                  'text-[14px]/[20px] text-base-1000 font-medium',
                  disabled && 'text-base-400',
                )}
              >
                {label}
              </p>
            </div>
          ))}
        </div>
      </Popover>
    </>
  );
};
